import { Delete } from "@mui/icons-material";
import { Box, Button, Checkbox, FormControlLabel, FormLabel, Typography } from "@mui/material";
import { useState } from "react";
import { useDeleteCampaign } from "../../../App/Queries/CampaignQueries";
import DialogInner from "./DialogInner";

interface IDeleteCampaignDialogProps {
  campaignId: string;
  campaignName: string;
  handleSubmitDeleteCampaign: (campaignId: string, shouldDeleteGroup: boolean) => void;
  handleClearDialog: () => void;
}

// TODO: Determine Campaign Group deletion logic and processes

export default function DeleteCampaignInner({
  campaignId,
  campaignName,
  handleSubmitDeleteCampaign,
  handleClearDialog,
}: IDeleteCampaignDialogProps) {
  const [shouldArchiveGroup, setShouldArchiveGroup] = useState(false);
  const { isLoading } = useDeleteCampaign();

  function handleChangeArchiveGroup() {
    setShouldArchiveGroup(!shouldArchiveGroup);
  }

  return (
    <DialogInner title="Delete Form" id="deletecampaign" handleClearDialog={handleClearDialog}>
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <Typography sx={{ mb: "1em" }}>
          Are you sure you want to delete the form <strong>{campaignName}</strong>? This cannot be undone!
        </Typography>
        <FormLabel
          component="legend"
          htmlFor="should-archive-group"
          sx={{ fontSize: "0.85em", fontWeight: "bold" }}
          onClick={handleChangeArchiveGroup}
        >
          Should Form Group be Archived?
        </FormLabel>
        <FormControlLabel
          control={
            <Checkbox
              data-test="deletecampaign-should-archive-group"
              id="should-archive-group"
              checked={shouldArchiveGroup}
              onChange={handleChangeArchiveGroup}
            />
          }
          label="(Optional) Archive Form Group"
        />
        <FormLabel htmlFor="should-archive-group" sx={{ mb: "1em", fontStyle: "italic", fontWeight: 400 }}>
          <strong>NOTE:</strong>{" "}
          {shouldArchiveGroup
            ? "Form Group will also be archived."
            : "If the Form Group has no candidates, it will also be archived.  If the Form Group has candidates it can be archived at a later time."}
        </FormLabel>
        <Button
          data-test="deletecampaign-submit"
          id="deletecampaign-submit"
          disabled={isLoading}
          onClick={() => handleSubmitDeleteCampaign(campaignId, shouldArchiveGroup)}
          variant="contained"
          endIcon={<Delete fontSize="small" />}
          sx={{ mr: "auto", my: "1em" }}
        >
          Delete Form
        </Button>
      </Box>
    </DialogInner>
  );
}
